export var DatePickerRange;
(function (DatePickerRange) {
    DatePickerRange[DatePickerRange["lastWeek"] = 0] = "lastWeek";
    DatePickerRange[DatePickerRange["lastMonth"] = 1] = "lastMonth";
    DatePickerRange[DatePickerRange["customRange"] = 2] = "customRange";
})(DatePickerRange || (DatePickerRange = {}));
export var DatePickerError;
(function (DatePickerError) {
    DatePickerError[DatePickerError["MissingDate"] = 1] = "MissingDate";
    DatePickerError[DatePickerError["MaxMonthRange"] = 2] = "MaxMonthRange";
    DatePickerError[DatePickerError["SwitchedStartEnd"] = 3] = "SwitchedStartEnd";
})(DatePickerError || (DatePickerError = {}));
